import { CookieName as BaseCookieName }	from "ts-base/web/cookieName";

import { Textual }	from "@v3/data/textual";

export type CookieName	= Textual.Value<typeof CookieName>;
export const CookieName	= Textual.fromBase(BaseCookieName, "must be an RFC 6265 cookie name");
